var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content"},[_c('table',{ref:"tablesuswa",staticClass:"table table-hover"},[_vm._m(0),_c('tbody',{on:{"click":_vm.handleClick}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("TANGGAL UJIAN")]),_c('th',[_vm._v("MAPEL")]),_c('th',[_vm._v("NAMA UJIAN")]),_c('th',[_vm._v("NILAI")])])])
}]

export { render, staticRenderFns }